import React, { ReactElement } from "react";

import { TrackerAppShell } from "./TrackerAppShell";

export function getFullWidthLayout(page: ReactElement) {
  return <TrackerAppShell contentBackground="#F0F3F5">{page}</TrackerAppShell>;
}
